/**
 * Creates an object containing a Promise along with the promise's `resolve` and `reject` functions.
 * This utility is useful for scenarios when you need to resolve or reject a Promise from outside its executor function.
 *
 * @returns {{ promise: Promise<unknown>, resolve: (value: unknown) => void, reject: () => void }}
 * Returns an object with the following properties:
 * - `promise`: The created Promise instance.
 * - `resolve`: The resolve function for the created Promise.
 * - `reject`: The reject function for the created Promise.
 */
export const promiseWithResolvers = () => {
  let resolve: (value: unknown) => void;
  let reject: () => void;

  const promise = new Promise((resolveFunc, rejectFunc) => {
    resolve = resolveFunc;
    reject = rejectFunc;
  });

  return {
    promise,
    // @ts-expect-error TS2454
    resolve,
    // @ts-expect-error TS2454
    reject,
  };
};
